<template>
  <v-container>
    <h1>{{ action }} Devotional</h1>
    <v-form>
      <v-alert
        v-model="isError"
        dismissible
        type="error"
        transition="fade-transition"
      >
        {{ errMessage }}
      </v-alert>

      <devotional-set-select
        v-model="devotional.setID"
      />

      <v-text-field
        v-model="devotional.index"
        label="Index"
        :error-messages="errors.index"
        id="index"
        @focus="inputFocus"
      />

      <bible-passage-select
        v-model="devotional.passage"
        :error-messages="errors.passage"
        id="passage"
        @focus="inputFocus"
      />

      <v-text-field
        v-model="devotional.videoURL"
        label="Video URL"
        :error-messages="errors.videoURL"
        id="videoURL"
        @focus="inputFocus"
      />

      <v-textarea
        v-model="devotional.thoughtText"
        label="Thought Text"
        :error-messages="errors.thoughtText"
        id="thoughtText"
        @focus="inputFocus"
      />

      <v-textarea
        v-model="devotional.prayerText"
        label="Prayer Text"
        :error-messages="errors.prayerText"
        id="prayerText"
        @focus="inputFocus"
      />

      <v-btn
        @click="submit"
      >Save</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import DevotionalSetSelect from '@/components/devotional-set-select'
import BiblePassageSelect from '@/components/bible-passage-select'

export default {
  data: () => ({
    devotional: {
      setID: null,
      index: null,
      passage: null,
      videoURL: null,
      thoughtText: null,
      prayerText: null
    },

    isError: false,
    errMessage: null,
    errors: {
      setID: null,
      index: null,
      passage: null,
      videoURL: null,
      thoughtText: null,
      prayerText: null
    }
  }),
  computed: {
    action: function () {
      let id = this.$route.params.id
      if (id === 'new') {
        return 'Add'
      } else {
        return 'Edit'
      }
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    // If we're making a new devotional, we're done
    if (id === 'new') {
      return
    }

    // Otherwise, we need to load data for the devotional
    var _this = this
    this.axios.get('/devotionals/' + id)
      .then(function (res) {
        // Sanity check before assigning the value
        if (res.data.length > 0) {
          _this.devotional = res.data[0]
        } else {
          throw new RangeError('No devotional information returned')
        }
      })
      .catch(this.$root.apiErrorHandler(function (msg, errors, err) {
        // If our error is a 404, that means we got a bogus devo ID value and
        // we can safely abort back to the devo listing page. Otherwise, we want
        // to render our error message.
        if (err && err.response && err.response.status === 404) {
          return _this.$router.push('/admin/devotionals')
        } else {
          _this.errMessage = msg
          _this.isError = true
        }
      }))
  },
  methods: {
    submit: function (ev) {
      var _this = this

      // Set up the proper request based on whether we're editing or creating
      let url = '/devotionals'
      let method = 'POST'
      let id = this.$route.params.id
      if (id !== 'new') {
        url += '/' + id
        method = 'PUT'
      }

      // Now send the POST or PUT request
      this.axios.request({
        method,
        url,
        data: this.devotional
      })
        .then(function (res) {
          _this.$router.push('/admin/devotionals')
        })
        .catch(this.$root.apiErrorHandler(function (msg, errors) {
          _this.errMessage = msg
          _this.errors = errors
          _this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  },
  components: {
    DevotionalSetSelect,
    BiblePassageSelect
  }
}
</script>
